/**
 * PageWrapper — verplichte buitenste wrapper van elke pagina.
 * Dwingt het breedte- + spacing-contract af (R11 design system).
 *
 * Props:
 *   children   — pagina-inhoud
 *   width      — 'default' (1280px) | 'narrow' (900px) | 'full' (geen max)
 *   className  — extra classes (optioneel)
 *
 * Spacing: vaste gap-7 (28px) tussen directe kinderen = het sectie-ritme
 * uit het contract. Pagina's laten hun eigen mb-* op top-level secties vallen.
 *
 * Let op (Fase B, eerste-pagina-bevinding): de Layout-<main> padt al met p-8.
 * PageWrapper voegt daarom GEEN eigen padding toe (alleen max-breedte +
 * centrering + sectie-ritme), anders zou het dubbel padden op elke pagina.
 */
export function PageWrapper({ children, width = 'default', gap = '7', className = '' }) {
  const maxW = {
    default: 'max-w-[1280px]',
    narrow: 'max-w-[900px]',
    full: 'max-w-none',
  }[width] ?? 'max-w-[1280px]'

  // gap='none' voor pagina's met een strakke toolbar+tabel-cluster die hun
  // eigen mb-* behouden; default '7' = sectie-ritme.
  const gapClass = { '7': 'gap-7', '6': 'gap-6', '4': 'gap-4', none: '' }[gap] ?? 'gap-7'

  return (
    <div className={`${maxW} mx-auto flex flex-col ${gapClass} ${className}`}>
      {children}
    </div>
  )
}
